const migrations = {
    events: {
        name: 'events',
        version: 3,
        stores: [
            { name: 'detailed_event', keyPath: 'id' },
            { name: 'event', keyPath: 'id' },
            { name: 'sms', keyPath: 'id' },
            { name: 'helicopter', keyPath: 'id' }
        ]
    },
    tiles: {
        name: 'tiles-cache',
        version: 1,
        stores: [
            { 
                name: 'tiles', 
                keyPath: 'url', 
                indexes: [
                    {name: 'ts', keyPath: 'ts'}
                ],
            }
        ]
    }
};

export default migrations;